import React from 'react';

import { Box, Container } from '@mui/material';

interface MinimalLayoutWrapperProps {
    children: any;
}

const MinimalLayoutWrapper: React.FC<MinimalLayoutWrapperProps> = ({ children })=> (
    <Container component="main" maxWidth="xs">
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            { children }
        </Box>
    </Container>
);

export default MinimalLayoutWrapper;
